<div class="modal fade show z" [ngClass]="{'expanded': isExpanded}" id="service-order-modal" tabindex="-1"
    aria-labelledby="service-order-modalLabel" aria-hidden="true" [ngStyle]="{'display': 'block'}">
    <div class="modal-dialog modal-lg">
     @if (showLoader) {
<app-loader></app-loader>
}
        <div class="modal-content">
            <app-popup-header
                [isExpanded]="isExpanded"
                [hideCreationDate]="hideCreationDate"
                [title]="title"
                (onClose)="close()"
                (onExpandCollapse)="expandCollapse($event)"
            ></app-popup-header>

            @if (gridConfig) {
            <div [style.height.px]="gridHeight">
                <inavista-grid #linkServiceOrdersGrid class="so-popup-grid"
                    [config]="gridConfig"
                    (rowsSelected)="onRowsSelected($event)"
                    (exportRequested)="onExportRequested()" />
            </div>
            }

            <div class="modal-footer">
                <button type="button" class="btn btn-sm btn-danger close-modal" (click)="close()">Close</button>
                <button type="button" class="btn btn-sm btn-success close-modal" (click)="add()">Add</button>
           </div>
       </div>

   </div>
</div>
